import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Table, Button } from 'reactstrap';
import './PatientList.css';
import TitlePage from '../../containers/Header/TitlePage';
import { age, hasKeys } from '../simpleFunctions';
import BeatLoader from 'react-spinners/BeatLoader';
import { css } from '@emotion/core';
import { resetPatient, resetPatientError } from '../../actions/patient';
import { resetQnaire } from '../../actions/questionnaire';
import { resetRec } from '../../actions/recommendations';
import { Navbar, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';
import { msalConfig, tokenRequest, logoutUrl } from '../../config-client';
import { callApiWithB2CToken } from '../../actions/callApi';

const Msal = require('msal');

const myMSALObj = new Msal.UserAgentApplication(msalConfig);

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

const styles = {
  margin: '115px',
  logout: {
    cursor: 'pointer',
  },
};

class PatientList extends Component {
  state = {
    // Use: this state value is used to check if a patient has been selected and to redirect to the patient home
    redirect: false,
    // Use: this state value is used to check if the user has selected to edit patient resource and to redirect to the patient edit pages
    edit: false,
    // Use: this state value is used to check if the user has selected to create a new patient resource and to redirect to the patient edit pages
    new: false,

  };

  // Use: set the state depending on what is clicked
  redirectfunction = (isHome, isNewPatient) => {
    // if user has double clicked on a patient or clicked on "let's go", then redirect to patient home
    if (isHome) {
      this.setState({ redirect: true });
    // if it's not a patient selection and the patient is not new, redirect to patient edit with repopulation set to true
    } else if (!isHome && !isNewPatient) {
      this.setState({ edit: true });
    // if it's not a patient selection and the user has clicked on "add patient", redirect to the edit page with repopulation set to false
    } else if (!isHome && isNewPatient) {
      this.setState({ new: true });
    }
  };

  // Use: display list once the backend request has returned something and it's not an error
  DisplayList = () => {
    // Use: return the table of patients if the request to the backend has not returned an error
    if (!hasKeys(this.props, 'patient.list.Error') &&
      this.props.patient.list != null &&
      !hasKeys(this.props, 'patient.list.stack') &&
      Object.keys(this.props.patient.list).length !== 0 &&
      // TODO: make these when statusCode !== <anything>
      this.props.patient.list.statusCode !== 401 &&
      this.props.patient.list.statusCode !== 500) {
      // #TODO - HARDCODED - MUST CHANGE

      return (
        <div>
          <Table>
            <thead>
              <tr>
                <th>Patient</th>
                <th>Age</th>
                <th>Edit</th>
              </tr>
            </thead>
            <tbody>{this.GeneratePatients()}</tbody>
          </Table>
        </div>
      );
    }
    // Use: show a spinner to let user know the data is being fetched
    return (
      <div style={styles}>
        <BeatLoader
          css={override}
          sizeUnit="px"
          size={40}
          color="#41AAD9"
          loading={this.props.patient.fetching}
        />
      </div>
    );
  }

  // Use: component to render each row in the table of patients
  GeneratePatients = () => this.props.patient.list.map((value, i) => (
    <tr
      className={
        i === this.state.selected ? 'active-patient' : 'inactive-patient'
      }
      onDoubleClick={() => this.redirectfunction(true, false)}
      onClick={() => {
        this.setState({ selected: i, patient: value });
        this.props.setActive(value);
      }}
      key={i}
    >
      <td>{value.resource.name[0].given[0]} {value.resource.name[0].family}</td>
      <td>{age(value.resource.birthDate, 'YYYY-MM-DD')}</td>
      <td><Button
        onClick={() => {
          this.redirectfunction(false, false);
        }
        }
      >
                    Edit
          </Button>
      </td>

    </tr>


  ));

  // Use: function to redirect the user to the logout b2clogout endpoint
  logoutUser = () => {
    const url = logoutUrl;
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return myMSALObj.acquireTokenSilent(tokenRequest)
      .then(tokenResponse => callApiWithB2CToken(url, tokenResponse.accessToken, headers, 'GET')
        .then(response => response.json()))
      .then((json) => {
        return myMSALObj.logout();
      })
      .catch(error => (
        <div>
            An error occurred in patienthomenav.js
        </div>
      ));
  }


  componentDidMount() {
    // reset recommendations reducer state
    this.props.resetRec();
    // reset request errors upon reloading
    this.props.resetUserError();
    // reset patient reducer state
    this.props.resetPatient();
    // reset questionnaire reducer state
    this.props.resetQnaire();
    // reset request errors upon reloading
    this.props.resetPatientError();
    // set the user, the clinician in this case
    this.props.setUser();
    // call to the backend to get the list of patients
    this.props.getList();
  }

  render() {
    if (this.props.clinician.error === "Error: User not logged in") {
      return (
      <div>
        <Redirect
            to={{
              pathname: "/",
            }}
          />
      </div>);
    }

    // Use: if call to backend results in an error, redirect to landing page
    if (this.props.patient.error === '' || this.props.clinician.error === '') {
      this.props.history.push('/');
      return null;
    }

    // if the clinician/user has not been loaded properly then return to landing page with an error message
    if (hasKeys(this.props, 'clinician.status')) {
      return (
        <div>
          <Redirect
            to={{
              pathname: '/',
              state: { error: this.props.clinician.error },
            }}
          />
        </div>
      );
    }
    return (
      <div className="patients-page">
        {this.state.redirect ? (
          <Redirect
            to={{
              pathname: '/PatientHome',
              state: { patient: this.state.patient },
            }}
          />
        ) : null}
        {this.state.edit ? (
          <Redirect
            to={{
              pathname: '/PatientEdit',
              state: {
                patient: this.state.patient,
              },
            }}
          />
        ) : null}
        {this.state.new ? (
          <Redirect
            to={{
              pathname: '/PatientEdit',
              state: {
                patient: this.state.patient,
              },
              new: true,
            }}
          />
        ) : null}
        <TitlePage />
        <br />
        <div className="patientinfonav">
          <Navbar light expand="md">
            <NavbarBrand>Welcome</NavbarBrand>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink style={styles.logout} onClick={() => { this.logoutUser(); }}>Logout</NavLink>
              </NavItem>
            </Nav>
          </Navbar>
        </div>
        <div className="patient-container">
          <div className="patient-title">
            <div className="patient-header">Patient List</div>
            <div className="add-patient">
              <Button onClick={() => {
                this.redirectfunction(false, true);
              }
              }
              >
                    Add Patient
              </Button>
            </div>
          </div>
          <div className="patient-table">
            {this.DisplayList()}
          </div>
          <div className="patient-buttons">
            <Button
              onClick={
                this.state.patient
                  ? () => this.redirectfunction(true, false)
                  : () => alert('Please select a patient')
              }
            >
                  Let's Go!
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  patient: state.patient,
  questionnaire: state.questionnaire,
  recommendations: state.recommendations,
  clinician: state.clinician,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      resetPatient,
      resetQnaire,
      resetRec,
      resetPatientError,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(PatientList);



// WEBPACK FOOTER //
// ./src/components/PatientList/PatientList.js